module.exports = __webpack_public_path__ + "img/7-1.ee67b6b9.png";